module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HZQXSD.cdc56d78.jpg";